import { render } from "./FlagPL.vue?vue&type=template&id=68231e83"
import script from "./FlagPL.vue?vue&type=script&lang=js"
export * from "./FlagPL.vue?vue&type=script&lang=js"

import exportComponent from "/home/twig/Work/FRONT/adsquiz.front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__